module.exports = __webpack_public_path__ + "img/icon_close.ec66c0a6.svg";